var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "app-main" }, [
    _c(
      "div",
      { attrs: { name: "fade-transform", mode: "out-in" } },
      [
        _c(
          "keep-alive",
          [
            _vm.$route.meta.keepAlive
              ? _c("router-view", { key: _vm.key })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.$route.meta.keepAlive == null || _vm.$route.meta.keepAlive == false
          ? _c("router-view", { key: _vm.key })
          : _vm._e(),
        _vm._v(" "),
        _c("password", { ref: "password" })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }